import React, { useState } from 'react'
import ReactModal from 'react-modal'
import { Capacitor } from '@capacitor/core'

import { t } from 'translations'
import { Button } from 'components/Forms'

// Bind the modal to the root element
if (!process.env.IS_TEST) {
  ReactModal.setAppElement('#root')
}

// Returns a modal component as well as a function to toggle it
const useModal = ({ shouldCloseOnOverlayClick = true, basicText, destructive } = {}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modalData, setModalData] = useState({}) // Stores state that can be used for actions within the modal

  // Data variable can be used to store data to be sent to the primaryAction
  const openModal = async (data = {}, modalOpen = true) => {
    setModalData(data)
    setIsOpen(modalOpen)
  }

  const modalComponent = ({ children, disablePrimaryAction, title, primaryAction, primaryActionText, secondaryAction, hideButtons, summary }) => (
    <ReactModal
      isOpen={isOpen}
      className="merinio-modal"
      overlayClassName={`merinio-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-app' : ''}`}
      shouldFocusAfterRender
      // These two lines are required to allow closing when the user clicks outside of the modal
      onRequestClose={() => setIsOpen(false)}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <div className="w-100 h-100 d-flex flex-column">
        <div className="flex-fill mb-2">
          <h4>{t(basicText ? title : `${title}.TITLE`)}</h4>
          {t(basicText ? summary : `${title}.SUMMARY`) && <div>{t(`${title}.SUMMARY`)}</div>}
          {children}
        </div>
        {!hideButtons && (
          <div>
            {/* This button only appears if a primary action exists */}
            {(() => {
              if (typeof primaryAction === 'function') {
                return (
                  <Button
                    disabled={disablePrimaryAction}
                    className={`btn btn-${destructive ? 'danger' : 'primary'} mr-2`}
                    onClick={() => {
                      setIsOpen(false)
                      // Execute primary action
                      primaryAction(modalData)
                    }}
                    data-cy="modal-primary-action"
                  >
                    {t(basicText ? primaryActionText : `${title}.PRIMARY_ACTION`)}
                  </Button>
                )
              } else {
                return primaryAction
              }
            })()}

            <Button
              className="btn btn-outline-secondary"
              onClick={() => {
                setIsOpen(false)
                if (secondaryAction) secondaryAction()
              }}
            >
              {t(`actions.CLOSE`)}
            </Button>
          </div>
        )}
      </div>
    </ReactModal>
  )

  return [modalComponent, openModal, setModalData]
}

export default useModal
